import { useState } from 'react';

const usePlannedOrders = () => {
  const [plannedOrders, setPlannedOrders] = useState([]);
  const [materialViewState, setMaterialViewState] = useState({});

  const resetPlannedOrders = () => {
    setPlannedOrders([]);
    setMaterialViewState({});
  };

  const updatePlannedOrders = (items) => {
    setPlannedOrders(items);
  };

  return {
    plannedOrders, updatePlannedOrders, resetPlannedOrders, materialViewState, setMaterialViewState,
  };
};

export default usePlannedOrders;
